import { Link, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiFileText } from "react-icons/fi";
import { Link as RouterLink } from "react-router-dom";
import { EventDataDto } from "../../autogen/bff-api";
import { TipTap, isTiptapContentEmpty } from "../../common/input/TipTap/TipTap";
import { urls } from "../../urls";
import { LabelValueGrid } from "../sourcing-events/portal/view-single/LabelValueGrid";
import { SectionCard } from "../sourcing-events/portal/view-single/SectionCard";

const DASH = "–";

interface Props {
  eventData: EventDataDto;
  derivedPlaceOfPerformance?: string | null;
  isPrivateEvent?: boolean;
}

export const AboutSection = ({ eventData, derivedPlaceOfPerformance, isPrivateEvent }: Props) => {
  const { t } = useTranslation();
  const place = eventData.placeOfPerformance;
  const options = eventData.options;

  const ownPlace = [place?.countrySubdivision, place?.countryCode, place?.servicesOther]
    .filter(Boolean)
    .join(", ");

  const placeOfPerformance = ownPlace || derivedPlaceOfPerformance || (
    <>
      {t("Not specified")}{" "}
      <Link as={RouterLink} to={urls.app.organizationProfileEdit} color="smPrimary">
        {t("Add an address to the company profile")}
      </Link>
    </>
  );

  const rows = [
    ...(isPrivateEvent ? [] : [{ label: t("Place of performance"), value: placeOfPerformance }]),
    ...(options?.hasOptions
      ? [{ label: t("Options"), value: options.descriptions?.join("; ") || t("Yes") }]
      : []),
  ];

  return (
    <SectionCard icon={FiFileText} title={t("About the procurement")}>
      <Stack spacing="5">
        <Stack spacing="1">
          <Text color="smMuted" fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide">
            {t("Description")}
          </Text>
          {!isTiptapContentEmpty(eventData.description) ? (
            <TipTap content={eventData.description ?? ""} editable={false} hasBorder={false} padding="0" />
          ) : (
            <Text color="smText" fontSize="sm">
              {DASH}
            </Text>
          )}
        </Stack>
        {rows.length > 0 && <LabelValueGrid rows={rows} />}
      </Stack>
    </SectionCard>
  );
};
